import { render, staticRenderFns } from "./goodsShortage.vue?vue&type=template&id=4e784e78&"
import script from "./goodsShortage.vue?vue&type=script&lang=js&"
export * from "./goodsShortage.vue?vue&type=script&lang=js&"
import style0 from "./goodsShortage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports